<template>
  <v-flex xs12>
    <section class="payment-modern-panel" :class="{ dark: isDark }">
      <div class="payment-modern-header">
        <v-avatar class="payment-modern-icon" size="38">
          <v-icon>mdi-cash-multiple</v-icon>
        </v-avatar>
        <div>
          <strong>Pagamentos</strong>
          <small>{{ status === "pago" ? "Venda quitada" : "Acompanhamento financeiro da venda" }}</small>
        </div>
      </div>

      <div class="payment-summary-grid">
        <div class="payment-summary-card">
          <small>Total da venda</small>
          <strong>{{ $helper.formataSaldo(total || 0) }}</strong>
        </div>
        <div class="payment-summary-card paid">
          <small>Ja foi pago</small>
          <strong>{{ $helper.formataSaldo(paid || 0) }}</strong>
        </div>
        <div class="payment-summary-card" :class="{ pending: remaining > 0, paid: remaining <= 0 }">
          <small>{{ remaining > 0 ? "Falta pagar" : "Quitado" }}</small>
          <strong>{{ $helper.formataSaldo(remaining || 0) }}</strong>
        </div>
      </div>

      <div v-if="paymentRows.length > 0" class="payment-list">
        <div
          v-for="row in paymentRows"
          v-show="row.payment.valor"
          :key="`pagamento-${row.index}`"
          class="payment-row"
        >
          <v-avatar size="34" color="#e8f7ef">
            <v-icon color="#1f8f55">mdi-check</v-icon>
          </v-avatar>
          <div class="payment-row-copy">
            <strong>{{ $helper.formataSaldo(row.payment.valor) }} em {{ row.payment.forma_de_pagamento }}</strong>
            <small>
              {{ $moment(row.payment.data).format("DD/MM/YY [as] HH:mm") }}
              <template v-if="row.receipt"> · recibo nº {{ saleNumber }}-{{ row.receipt.order }}</template>
            </small>
          </div>
          <v-chip v-if="row.payment.sign" x-small color="#dff5e8" text-color="#1f8f55">assinado</v-chip>
          <v-btn
            v-if="row.receipt"
            small
            text
            class="payment-reprint text-capitalize"
            :color="$theme.primary"
            @click="reprintReceipt(row)"
          >
            <v-icon left size="16">mdi-printer-outline</v-icon>
            Reimprimir recibo
          </v-btn>
        </div>
      </div>
      <div v-else class="payment-empty">
        <v-icon color="#8ea39a">mdi-credit-card-clock-outline</v-icon>
        <span>Nenhum pagamento informado ainda.</span>
      </div>
    </section>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { printReceipt } from "@/apps/shared/services/printSaleDocuments";
import { normalizeReceipt } from "@/apps/shared/services/receiptDocument";

export default {
  props: {
    payments: {
      type: Array,
      default: () => []
    },
    total: { type: Number, default: 0 },
    paid: { type: Number, default: 0 },
    remaining: { type: Number, default: 0 },
    status: { type: String, default: "pendente" }
  },
  computed: {
    ...mapGetters(["get_gestordepedido", "getLoggedUser"]),
    isDark() {
      return localStorage.dark === "true";
    },
    saleNumber() {
      return this.get_gestordepedido ? this.get_gestordepedido.id_transacao : "";
    },
    /**
     * Cada pagamento (exceto troco) recebe o recibo correspondente, montado a
     * partir do recibo salvo ou dos dados do proprio pagamento, para que a
     * reimpressao funcione tambem nos lancamentos antigos.
     */
    paymentRows() {
      const sale = this.get_gestordepedido || {};
      let receiptIndex = 0;
      return this.payments.map((payment, index) => {
        const isChange = payment && payment.forma_de_pagamento === "troco";
        const receipt = isChange
          ? null
          : normalizeReceipt({ sale, payment, index: receiptIndex++ });
        return { payment, index, receipt };
      });
    }
  },
  methods: {
    ...mapActions(["createGlobalMessage"]),
    reprintReceipt(row) {
      printReceipt({
        sale: this.get_gestordepedido,
        receipt: row.receipt,
        user: this.getLoggedUser,
        notify: this.createGlobalMessage,
        context: { vuetify: this.$vuetify }
      });
    }
  }
};
</script>

<style scoped>
.payment-modern-panel { margin: 10px 8px 14px; padding: 16px; border-radius: 20px; background: #f8fbf9; border: 1px solid #dfe9e4; box-shadow: 0 14px 34px rgba(15, 35, 28, .08); }
.payment-modern-header { display: flex; align-items: center; gap: 12px; margin-bottom: 14px; }
.payment-modern-header strong,.payment-modern-header small,.payment-summary-card strong,.payment-summary-card small,.payment-row-copy strong,.payment-row-copy small { display: block; }
.payment-modern-header strong { color: #14251d; font-size: 16px; }
.payment-modern-header small,.payment-summary-card small,.payment-row-copy small,.payment-empty { color: #6f8178; }
.payment-modern-icon { background: #e8f7ef !important; color: #1f8f55 !important; }
.payment-summary-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px; margin-bottom: 12px; }
.payment-summary-card { padding: 12px; border-radius: 16px; background: #fff; border: 1px solid #e4ece8; }
.payment-summary-card strong { margin-top: 4px; font-size: 17px; color: #14251d; }
.payment-summary-card.paid strong { color: #1f8f55; }
.payment-summary-card.pending strong { color: #c26a13; }
.payment-list { display: flex; flex-direction: column; gap: 8px; }
.payment-row { display: flex; align-items: center; gap: 10px; padding: 11px; border-radius: 16px; background: #fff; border: 1px solid #e4ece8; }
.payment-row-copy { flex: 1; min-width: 0; }
.payment-reprint { flex-shrink: 0; }
@media(max-width: 600px) { .payment-row { flex-wrap: wrap; } .payment-reprint { margin-left: 44px; } }
.payment-empty { display: flex; align-items: center; justify-content: center; gap: 8px; padding: 22px; border-radius: 16px; border: 1px dashed #cbd8d1; }
.payment-modern-panel.dark { background: #111b21; border-color: #26343c; box-shadow: none; }
.payment-modern-panel.dark .payment-modern-header strong,.payment-modern-panel.dark .payment-summary-card strong,.payment-modern-panel.dark .payment-row-copy strong { color: #eef4f1; }
.payment-modern-panel.dark .payment-modern-header small,.payment-modern-panel.dark .payment-summary-card small,.payment-modern-panel.dark .payment-row-copy small,.payment-modern-panel.dark .payment-empty { color: #8ea39a; }
.payment-modern-panel.dark .payment-summary-card,.payment-modern-panel.dark .payment-row { background: #182229; border-color: #26343c; }
.payment-modern-panel.dark .payment-modern-icon { background: #0b3b2a !important; color: #9be7bd !important; }
@media(max-width: 900px) { .payment-summary-grid { grid-template-columns: 1fr; } }
</style>
